module.exports = __webpack_public_path__ + "static/selectKPI-10d40eec58697be275241b3e08a9555e.gif";